import React from 'react';
import styled from 'styled-components';
import Button from '../button/Button';
import { KPMGCirclePlusWhiteIcon } from '../../../assets/icons';
import { Row, Col, Space } from 'antd';
import { ButtonClassType } from '../../../enums/buttons';
import { automationIds } from '../../../constants/automationIds';
import useAccessPolicy from '../../../hooks/useAccessPolicy';
import ContentHandler from '../ContentHandler';
import Search from './Search';
import LoadingButton from '../button/LoadingButton';
import FilterPopover from '../filter/FilterPopover';
const StyledRow = styled(Row) `
  margin-bottom: 24px;
`;
const SearchCol = styled(Col) `
  text-align: center;
`;
const FilterExportColumnsCol = styled(Col) `
  text-align: right;
`;
const TableActions = ({ config: { addItemButton, searchPlaceholder, hasHideableColumns, hasSearch, hasFilter, hasExport }, searchValue, handleSearch, handleAddItemAction, handleExportData, filterPopoverContent }) => {
    const canAddItem = useAccessPolicy(addItemButton === null || addItemButton === void 0 ? void 0 : addItemButton.policy);
    const hasActiveAction = (addItemButton && canAddItem) || hasSearch || hasExport || hasFilter || hasHideableColumns;
    if (!hasActiveAction)
        return null;
    return (<StyledRow>
      <Col span={8}>
        <ContentHandler shouldDisplayContent={addItemButton && canAddItem} render={() => (<Button icon={<KPMGCirclePlusWhiteIcon />} name={addItemButton.name} onClick={handleAddItemAction} automationId={automationIds.BUTTON.ADD}/>)}/>
      </Col>
      <SearchCol span={8}>
        <ContentHandler shouldDisplayContent={hasSearch} render={() => (<Search placeholder={searchPlaceholder} value={searchValue} onChange={event => handleSearch(event.target.value)} automationId={automationIds.DATA_ENTRY.SHARED.INPUT.SEARCH}/>)}>
        </ContentHandler>
      </SearchCol>
      <FilterExportColumnsCol span={8}>
        <Space>
          <ContentHandler shouldDisplayContent={hasFilter}>
            <FilterPopover content={filterPopoverContent} actionButton={({ onClick }) => (<Button onClick={onClick} name='TABLE.ACTIONS.FILTER' classType={ButtonClassType.Ghost} automationId={automationIds.BUTTON.FILTER}/>)}/>
          </ContentHandler>
          <ContentHandler shouldDisplayContent={hasHideableColumns}>
            <Button name='TABLE.ACTIONS.COLUMNS' classType={ButtonClassType.Ghost} automationId={automationIds.BUTTON.COLUMNS}/>
          </ContentHandler>
          <ContentHandler shouldDisplayContent={hasExport}>
            <LoadingButton name='TABLE.ACTIONS.EXPORT' classType={ButtonClassType.Ghost} automationId={automationIds.BUTTON.EXPORT} onClick={handleExportData}/>
          </ContentHandler>
        </Space>
      </FilterExportColumnsCol>
    </StyledRow>);
};
export default TableActions;
